import Agent from '../agent/base'
import city from '../gis/city'
import { toUrlParams } from '../base/url'
import { jump2TemplateMethod } from './base'
import { WX_PATH_PREFIX } from './mp-const'
import getDefaultDate from '../date'

interface I_DATE_PARAM {
  dateBegin?: string
  dateEnd?: string
  withDate?: boolean
}

interface I_PARAM extends I_DATE_PARAM {
  cityId?: string | number
  needCity?: boolean
  [x: string]: string | number | boolean | undefined
}

function getDateRange(params: I_DATE_PARAM) {
  const { withDate = true, dateBegin, dateEnd } = params
  // 设置默认日期
  let dateRange = {
    dateBegin,
    dateEnd,
  }
  if (withDate && !dateBegin && !dateEnd) {
    // 客户端参数名不统一要注意
    const { dateBegin, dateEnd } = getDefaultDate()
    dateRange = {
      dateBegin,
      dateEnd,
    }
  }
  return dateRange
}

export function getIPath(params: I_PARAM = {}): string {
  const { cityId = 310100, ...extras } = params
  const dateRange = getDateRange(params)
  const queryString = toUrlParams({ cityId, ...extras, ...dateRange })
  return `/filter-search?${queryString}`
}

// 美团 iOS 9.10.200、Android 9.9.8，美团民宿App iOS 3.4.5、Android 3.5.0 以上跳转RN, 其他跳转hybrid筛搜
// RN 筛搜支持情况 https://km.sankuai.com/page/130698171
/**
 * [$jump2filter 跳转到筛搜页]
 * @param  {[String]} params      [参数]
 */
export default async function jump2filter(params: I_PARAM = {}) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  let { withDate, needCity, cityId, ...extras } = params
  const dateRange = getDateRange(params)
  // 设置默认城市
  if ((Agent.native || needCity) && (!cityId || cityId === -1)) {
    // 获取定位会导致跳转延迟，默认直接跳
    try {
      cityId = (await city.get()) as number
      window.GUO.cityId = cityId
    } catch (e) {
      cityId = 310100
    }
  }
  const queryString = toUrlParams({ cityId, ...extras, ...dateRange })
  const iPath = `/filter-search?${queryString}`
  jump2TemplateMethod({
    iPath,
    mpPathMap: {
      // cityId, dateBegin, dateEnd
      dianping_wxapp: `${WX_PATH_PREFIX.dianpingSub}/products/products?${queryString}`,
      group_wxapp: `${WX_PATH_PREFIX.meituan}/products/simple?${queryString}`,
      hotel_wxapp: `${WX_PATH_PREFIX.hotelSub}/products/products?${queryString}`,
      phoenix_wxapp: `${WX_PATH_PREFIX.phx}/products/products?${queryString}`,
    },
    rnPathConfig: {
      versions: { phx: '3.5.0', meituan: '9.10.200', dianping: '10.14.0' },
      mrn_entry: 'filter',
      mrn_component: 'zhenguo-filter',
      params: { cityId, ...extras, ...dateRange },
    },
  })
}
